export enum ENTITY_TYPES {
  DASHBOARD = 'dashboard',
  ORDER = 'order',
  VENDOR = 'vendor',
  INVENTORY_ITEM_VENUE = 'inventory-item-venue',
  INVENTORY_ITEM = 'inventory-item',
  SITE = 'site',
  TRANSFER = 'transfer',
  TRANSFER_DESTINATIONS = 'transfer-destinations',
  EVENTS = 'events',
  STAND_WORKSHEET = 'stand-worksheet',
  STAND_WORKSHEET_ITEM = 'stand-worksheet-item',
  RECIPE_VENUE = 'recipe-venue',
  PRODUCT = 'product',
  PRODUCT_PRICE = 'product-price',
  INVENTORY_COUNT = 'inventory-count',
  INVENTORY_COUNT_GROUP = 'inventory-count-group',
  TAG = 'tag',
  EVENT_TYPE = 'event-type',
  HISTORICAL_QUANTITIES = 'historical-quantities',
  INCOMPLETE_TRANSFER = 'incomplete-transfer',
  CURRENCY_SCHEME = 'currency-scheme',
  TRANSFER_GROUP = 'transfer-group',
  SALE_DEPLETION_ORDER = 'sale-depletion-order',
  AUDIT_TRAIL = 'audit-trail',
  TRANSFER_GROUP_TEMPLATE = 'transfer-group-template',
  CART = 'cart',
  FILTERED_ORDER = 'filtered-order',
  FILTERED_TRANSFER = 'filtered-transfer',
  TRANSFER_REQUEST = 'transfer-request',
  COMMISSION_RATE = 'commission-rate',
  HAWKER_PROFILE = 'hawker-profile',
  REPORTING_CATEGORY = 'reporting-category',
  HAWKER_LOAD = 'hawker-load',
  // Virtual entity types for permission checks
  HAWKER_CONFIG = 'hawker-config',
  HAWKER_COMMISSARY_ASSIGNMENT = 'hawker-commissary-assignment',
  HAWKER_SESSION = 'hawker-session',
  HAWKER_COMMISSARY_ASSIGNMENT_HISTORY = 'hawker-commissary-assignment-history',
  HAWKER_SESSION_ADMIN = 'hawker-session-admin',
}
